import ApiService from '@/utils/ApiService'

export default {
  namespaced: true,
  state: {
    isLoading: false,
    created: null,
    violations: {}
  },
  getters: {
    error: (state) => state.error,
    isLoading: (state) => state.isLoading,
    created: (state) => state.created,
    violations: (state) => state.violations
  },
  mutations: {
    toggleLoading (state) {
      state.isLoading = !state.isLoading
    },
    setCreated (state, created) {
      state.created = created
    },
    setViolations (state, violations) {
      state.violations = violations
    },
    reset (state) {
      state.created = null
      state.isLoading = false
      state.violations = {}
    }
  },
  actions: {
    async create ({ commit }, data) {
      commit('toggleLoading')
      const response = await new ApiService('e_x_c_m_notification_messages').post(data)
      if (response.status < 300) commit('setCreated', await response.json())
      else commit('setViolations', response)
      commit('toggleLoading')
    },
    reset ({ commit }) {
      commit('reset')
    }
  }
}
